import React, { useState, useEffect } from 'react'
import { ref, remove, get, orderByChild, query, onValue } from 'firebase/database';
import { errorToast, successToast } from '../../../common/toast';
import AddNewPackage from './AddewPackage';
import { db } from '../../../../firebase';
import AddModel from '../../../common/AddModel';
import DataTable from '../../../common/Table';

const Packages = () => {

  const [isAddModel, setIsAddModel] = useState(false);
  const [packages, setPackages] = useState([]);
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      Header: "Plan Name",
      accessor: "planName",
    },
    {
      Header: "No Of Forms",
      accessor: "noOfForms",
    },
    {
      Header: "Plan Duration",
      accessor: "planDuration",
    },
  ];

  const handleEdit = (packageItem) => {
    setEditData(packageItem);
    setIsAddModel(true);
  };

  const handleDelete = async (packageItem) => {
    if (window.confirm(`Are you sure you want to delete ${packageItem.planName}?`)) {
      try {
        const packageRef = ref(db, `packages/${packageItem.id}`);
        await remove(packageRef);
        successToast(`${packageItem.planName} has been deleted!`);
        fetchPackages();
      } catch (error) {
        errorToast("Error deleting package: " + error.message);
      }
    }
  };

  const actionButtons = [
    {
      icon: 'bi bi-pencil',
      onClick: handleEdit,
    },
    {
      icon: 'bi bi-trash',
      color: 'danger',
      onClick: handleDelete,
    },
  ];

  const fetchPackages = async () => {
    setIsLoading(true);
    let packagesData = [];
    try {
      const qcReportsRef = query(ref(db, "packages"), orderByChild("registrationDate"));
      onValue(qcReportsRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          packagesData = Object.keys(data)
            .map(id => ({ id, ...data[id] }))
            .reverse();
        }

        setPackages(packagesData);
        setIsLoading(false)
      })
      // const packagesRef = ref(db, 'packages');
      // const queryRef = query(packagesRef, orderByChild('registrationDate'));
      // const snapshot = await get(queryRef);

      // const usersRef = ref(db, "users");

      // if (snapshot.exists()) {
      //   const data = snapshot.val();
      //   packagesData = Object.keys(data)
      //     .map(id => ({ id, ...data[id] }))
      //     .reverse();
      // }

      // setPackages(packagesData);
    } catch (error) {
      errorToast("Error fetching packages: " + error.message);
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchPackages();
  }, []);

  return (
    <>
      <DataTable
        title={"Packages"}
        isAddNew={() => {
          setEditData();
          setIsAddModel(true);
        }}
        isLoading={isLoading}
        tableData={packages}
        columns={columns}
        actionButtons={actionButtons}
      />

      {isAddModel &&
        <AddModel
          title={editData && Object.entries(editData)?.length ? "Edit Package" : "Add Package"}
          isAddModel={isAddModel}
          setIsAddModel={setIsAddModel}
          message={
            <AddNewPackage
              fetchPackages={fetchPackages}
              setIsAddModel={setIsAddModel}
              editData={editData}
            />
          }
        />}
    </>
  )
}

export default Packages;
